(() => {
  if (window.feltwhimsySizeComparisonReady) return;
  window.feltwhimsySizeComparisonReady = true;

  const phoneHeightCm = 14.76;
  const format = (number) => Number(number.toFixed(2)).toString();

  function parseDimension(value) {
    if (!value) return null;
    const centimeters = String(value).match(/(\d+(?:\.\d+)?)\s*cm\b/i);
    const inches = String(value).match(/(\d+(?:\.\d+)?)\s*(?:inches|inch|in|[″"])/i);
    const cm = centimeters ? Number(centimeters[1]) : inches ? Number(inches[1]) * 2.54 : NaN;
    if (!Number.isFinite(cm) || cm < 2 || cm > 30) return null;
    return { cm, inches: inches ? Number(inches[1]) : cm / 2.54 };
  }

  function variantMedia(panel) {
    if (panel.sizeVariantMedia) return panel.sizeVariantMedia;
    try {
      panel.sizeVariantMedia = JSON.parse(panel.querySelector('[data-size-variant-media]')?.textContent || '[]');
    } catch {
      panel.sizeVariantMedia = [];
    }
    return panel.sizeVariantMedia;
  }

  function update(section, sizeValue, variantId) {
    const panel = section.querySelector('[data-size-comparison]');
    if (!panel) return;

    const size = parseDimension(sizeValue) || parseDimension(panel.dataset.productDimensions);
    panel.hidden = !size;
    if (!size) return;

    const label = `${format(size.cm)} cm / ${format(size.inches)} in`;
    const board = panel.querySelector('[data-comparison-chart]');
    board.style.setProperty('--figure-ratio', (size.cm / phoneHeightCm).toFixed(4));
    board.setAttribute('aria-label', `${board.dataset.comparisonDescription} ${label}.`);
    panel.querySelector('[data-comparison-size]').textContent = label;
    panel.querySelector('[data-comparison-height]').textContent = label;

    const measure = section.querySelector('[data-size-measure-value]');
    if (measure && sizeValue && parseDimension(sizeValue)) {
      measure.textContent = format(size.cm);
      const unit = document.createElement('span');
      unit.className = 'feltwhimsy-product-size__measure-unit';
      unit.textContent = ' cm';
      measure.append(unit);
      const caption = section.querySelector('[data-size-measure-caption]');
      if (caption) caption.textContent = sizeValue.split(' / ')[0]?.trim() || `${format(size.inches)} in`;
    }

    const selectedMedia = variantMedia(panel).find((item) => String(item.id) === String(variantId));
    if (selectedMedia?.image) {
      const photo = panel.querySelector('.feltwhimsy-size-modal__photo');
      if (photo) {
        photo.src = selectedMedia.image;
        photo.srcset = '';
        photo.alt = selectedMedia.alt || '';
      }
      const thumbnail = panel.querySelector('.feltwhimsy-size-compare__thumb');
      if (thumbnail) {
        thumbnail.src = selectedMedia.thumbnail || selectedMedia.image;
        thumbnail.srcset = '';
      }
    }
    const width = panel.querySelector('[data-comparison-width]');
    if (width) {
      const measuredWidth = parseDimension(selectedMedia?.width);
      width.textContent = measuredWidth ? `${format(measuredWidth.cm)} cm / ${format(measuredWidth.inches)} in` : width.dataset.widthUnavailable;
    }
  }

  function sync(root = document) {
    root.querySelectorAll('.feltwhimsy-product-size').forEach((section) => {
      const panel = section.querySelector('[data-size-comparison]');
      if (!panel) return;
      const picker = document.querySelector('variant-picker[data-template-product-match="true"] [data-size-picker] input:checked');
      update(section, picker?.value || panel.dataset.selectedSize, panel.dataset.selectedVariantId);
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest('[data-size-compare-open]');
    if (openButton) {
      const dialog = openButton.closest('[data-size-comparison]')?.querySelector('[data-size-compare-dialog]');
      if (dialog && !dialog.open) dialog.showModal();
      return;
    }
    const closeButton = event.target.closest('[data-size-compare-close]');
    if (closeButton) closeButton.closest('dialog')?.close();
  });

  document.addEventListener('click', (event) => {
    if (!event.target.matches('[data-size-compare-dialog]')) return;
    const bounds = event.target.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) event.target.close();
  });

  document.addEventListener('change', (event) => {
    if (!event.target.matches('variant-picker[data-template-product-match="true"] [data-size-picker] input')) return;
    document.querySelectorAll('.feltwhimsy-product-size').forEach((section) => {
      const panel = section.querySelector('[data-size-comparison]');
      update(section, event.target.value, panel?.dataset.selectedVariantId);
    });
  });

  document.addEventListener('shopify:product:select', (event) => {
    if (!event.target?.matches?.('variant-picker[data-template-product-match="true"]') || !event.promise) return;
    event.promise.then(({ variant }) => {
      const size = variant?.selectedOptions?.find((option) => option.name.toLowerCase() === 'size')?.value;
      document.querySelectorAll('.feltwhimsy-product-size').forEach((section) => {
        const panel = section.querySelector('[data-size-comparison]');
        if (panel && variant?.id) panel.dataset.selectedVariantId = String(variant.id).split('/').pop();
        update(section, size || panel?.dataset.selectedSize, panel?.dataset.selectedVariantId);
      });
    }).catch(() => {});
  });

  document.addEventListener('shopify:section:load', () => sync());
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => sync(), { once: true });
  else sync();
})();
